import React from "react";
import NavBar from "../NavBar";
import AIDetector from "./AIDetector";
import Footer from "../Footer";
import WhyNeedAIDetector from "./WhyNeedAIDetector";
import DetectorResult from "./DetectorResult";
import { createContext, useState, useRef } from "react";
import { analytics } from "../../App";
import { logEvent } from "firebase/analytics";

//create context
export const aiDetectorContext = createContext({
  enter_ai_text: "",
  probability: 0,
  is_ai_generated: 0,
  text: "",
  isLoaded: false,
  detection_sentences: [],
  mode: 2,
});

function AIDetectorMain() {
  //detect texts form values
  const [aiDetectorTextsValues, setAIDetectorTextsValues] = useState({
    enter_ai_text: "",
    probability: 0,
    is_ai_generated: 0,
    text: "",
    isLoaded: false,
    detection_sentences: [],
    mode: 2,
  });

  //reference to detector result
  const detectorResultSectionRef = useRef(null);

  return (
    <div>
      {/*Firebase analytics */}
      {logEvent(analytics, "AI Detector Screen")}

      {/*Add title and metadata */}
      <title>
        AI checker for ChatGPT, Gemini, GPT-4 (100% Accuracy) for free
      </title>
      <meta name="robots" content="index, follow"></meta>
      <link rel="canonical" href="https://humanizetexts.com/ai-detector" />
      <meta
        name="description"
        content="Detect wheather a text is computer-generated or human written. Also, find out what percentage of the text is AI-generated and which sentences are most likely generated by artificial intelligence."
      ></meta>
      <meta
        name="keywords"
        content="ai detector,artificial intelligence detector,aı detector,ai detector free,chatgpt detector,ai detect,ai detecting,chatgpt detectors,detect ai,ai detection tool,gemini detector,bot detector,perplexity detector,copilot detector,"
      ></meta>
      <meta
        property="og:title"
        content="AI checker for ChatGPT, Gemini, GPT-4 (100% Accuracy) for free"
      />
      <meta
        name="twitter:title"
        content="AI checker for ChatGPT, Gemini, GPT-4 (100% Accuracy) for free"
      ></meta>

      {/* Main Content */}
      <aiDetectorContext.Provider
        value={{
          aiDetectorTextsValues,
          setAIDetectorTextsValues,
          detectorResultSectionRef,
        }}
      >
        <div className="p-3">
          {/* NavBar component */}
          <NavBar />
          {/*AI Detector*/}
          <AIDetector />
          {/* Detector Results*/}
          <DetectorResult />
          {/* Why Need AI Detector */}
          <WhyNeedAIDetector />
          {/* Footer */}
          <Footer />
        </div>
      </aiDetectorContext.Provider>
    </div>
  );
}

export default AIDetectorMain;
